import React from 'react';
import { SurveyNoActiveFeedback } from './SurveyNoActiveFeedback';

export const NoActiveSurvey = (): JSX.Element => <SurveyNoActiveFeedback />;
